// @ts-nocheck

import { colors } from '@lmc/common/constants'
import _ from 'lodash'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { withRouter } from '../../../withRouter'
import { ResidentListItem } from '../ResidentListItem'

class ResidentList extends PureComponent {
  constructor(props) {
    super(props)
    this.state = { filterValue: '' }
    this.handleChange = this.handleChange.bind(this)
    this.renderResidents = this.renderResidents.bind(this)
    this.renderFilterInput = this.renderFilterInput.bind(this)
  }

  componentDidMount() {
    const { data, resident_id, router } = this.props
    if (!resident_id && data && data.length) {
      const res_id = _.sortBy(data, 'name')[0].id
      router.navigate(`/reports/charts/dashboard/${res_id}`, { replace: true })
    }
  }

  handleChange(event) {
    this.setState({ filterValue: event.target.value })
  }

  renderResidents() {
    const { filterValue } = this.state
    const { resident_id } = this.props
    const pattern = new RegExp(filterValue, 'i')
    let { data } = this.props
    if (filterValue.length) data = data.filter((res) => res.name.match(pattern))

    return data.length ? (
      <ul style={styles.list}>
        {data.map((row) => (
          <ResidentListItem
            key={row.id}
            compact
            data={row}
            link={this.props.link}
            isActive={resident_id && row.id === resident_id}
          />
        ))}
      </ul>
    ) : (
      <p style={styles.noMatch}>No matches</p>
    )
  }

  renderFilterInput() {
    return (
      <div style={styles.filterContainer}>
        <input
          placeholder="Filter..."
          type="text"
          autoComplete="off"
          value={this.state.value}
          onChange={this.handleChange}
          style={styles.filter}
          className="FormInput"
          name="lmcResidentName"
        />
      </div>
    )
  }

  render() {
    const { data } = this.props
    return (
      <div style={styles.container}>
        {data && data.length > 5 ? this.renderFilterInput() : null}
        {this.renderResidents()}
      </div>
    )
  }
}

ResidentList.propTypes = {
  data: PropTypes.array,
  resident_id: PropTypes.string,
  router: PropTypes.object
}

const styles = {
  filterContainer: {
    paddingRight: 12,
    paddingLeft: 12
  },
  filter: {
    height: '3em',
    boxShadow: 'none',
    borderRadius: 0,
    borderColor: colors.black,
    fontWeight: 200,
    fontSize: 18
  },
  container: {
    width: '100%',
    marginTop: 18
  },
  list: {
    listStyle: 'none',
    paddingLeft: 0,
    cursor: 'pointer'
  },
  resident: {
    margin: 10,
    fontSize: 20
  },
  residentImg: {
    width: 60,
    height: 60
  },
  noMatch: {
    margin: 10,
    fontSize: 16,
    color: 'rgba(0,0,0,0.6)'
  }
}

export default withRouter(ResidentList)
